<template>
  <div id="app" class="flex flex-col min-h-screen bg-secondary-100">
    <AppNavbar v-if="showNavbar" />
    <main class="flex-1">
      <router-view />
    </main>
    <AppFooter v-if="showNavbar" />
    <CartDrawer />
    <AppToast />
  </div>
</template>

<script lang="ts">
import { defineComponent, computed, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'
import AppNavbar from '@/components/layout/AppNavbar.vue'
import AppFooter from '@/components/layout/AppFooter.vue'
import CartDrawer from '@/components/ui/CartDrawer.vue'
import AppToast from '@/components/ui/AppToast.vue'

export default defineComponent({
  name: 'App',
  components: { AppNavbar, AppFooter, CartDrawer, AppToast },
  setup () {
    const route = useRoute()
    const store = useStore()

    // Only hide navbar/footer for the authenticated vendor portal pages (those with sidebar)
    // Public vendor pages like /vendor/register and /vendor/pending keep the navbar
    const vendorPortalRoutes = ['/vendor', '/vendor/products', '/vendor/orders', '/vendor/earnings']
    const showNavbar = computed(() => {
      if (route.path.startsWith('/admin')) return false
      if (vendorPortalRoutes.includes(route.path)) return false
      return true
    })

    onMounted(() => {
      if (store.state.auth.token) {
        store.dispatch('auth/fetchCurrentUser')
      }
      store.dispatch('products/fetchProducts')
    })

    return { showNavbar }
  }
})
</script>
